function ErrorIcon() {
  return (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="4" y="4" width="32" height="32" rx="16" fill="#FCF0ED"/>
  <rect x="2" y="2" width="36" height="36" rx="18" stroke="#FCF0ED" strokeOpacity="0.5" strokeWidth="4"/>
  <path d="M20 16V20M20 24H20.01M30 20C30 25.5228 25.5228 30 20 30C14.4772 30 10 25.5228 10 20C10 14.4772 14.4772 10 20 10C25.5228 10 30 14.4772 30 20Z" stroke="#A82C0C" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
  );
}

export default ErrorIcon;



